import { combineReducers } from 'redux';
import { appFeatureReducer } from './app';
import { authFeatureReducer } from './auth';
import { alertReducer } from './alert';
import { chatFeatureReducer } from './chat';


const featuresReducer = combineReducers({
  app: appFeatureReducer,
  auth: authFeatureReducer,
  alert: alertReducer,
  chat: chatFeatureReducer,
});

export { featuresReducer };

export * from './auth';
export * from './app';
export * from './alert';
export * from './chat';
